<template>
	<div class="address-wrap">
		<!-- <transition name="slideup"> -->
			
			<div class="address-list" v-if="hasList">
				<div
					class="address"
					
					v-for="c in address"
					:key="'address-' + c.id"
				>
					<div class="recieve-wrap">
						<div class="reciever" @click.stop="select(c)">{{ c.receiver }}</div>
						<div class="contact" @click.stop="select(c)">{{ c.telephone }}</div>
					</div>
					
					<div class="detail" @click.stop="select(c)">{{ c.area + c.detail }}</div>
					<div class="flex-wrap action-wrap">
						<div class="default-address flex-wrap" v-bind:class="c.defaultAddress" @click="setDefault(c)">
							<Icon class="icon" v-if="c.defalultIcon" :img="require('../../assets/xuanzhong_press_icon.png')" />
							<Icon class="icon" v-else :img="require('../../assets/xuanzhong_normal_icon.png')" />
							设为默认
						</div>
						<div class="flex-wrap">
							<a class="write-btn flex-wrap" @click="goTo('/pages/setting/EditAddress?id='+c.id)">
								<Icon class="icon" :img="require('../../assets/bianji_icon.png')" />
							 	编辑
							</a>
							<div class="delete-btn flex-wrap" @click.stop="deleteAddress(c)">
								<Icon class="icon" :img="require('../../assets/shanchu_icon.png')" />
							 	删除
							</div>
						</div>
							<!-- <a href="javascript:;" class="delete-btn" @click.stop="deleteAddress(c)"></a></div> -->
					</div>
					
						<!-- <Icon
							class="icon"
							v-if="curr && curr.id == c.id"
							:img="require('../../../assets/icon-address-del-active.png')"
						/>
						<Icon class="icon" v-else :img="require('../../../assets/icon-address-del.png')" /> 删除 -->
					
				</div>
			</div>
			<div class="empty-list" v-else>
				<Icon class="empty-img" :img="require('../../assets/zanwudizhi_icon.png')" />
				<p>还没有收货地址哦~</p>
			</div>
			<!-- <ActionButton class="actions" text="新增收货地址" v-on:click.native="$emit('onAddAddress')" /> -->
			<ActionButton class="actions" text="新增收货地址" @click="goTo('/pages/setting/AddAddress')" />
		<!-- </transition> -->
	</div>
</template>

<script>
import api from '../../api';
import store from "../../api/store";
import ActionButton from '@/components/products/form/ActionButton'
export default {
	title: "地址管理",
	bodyClass: 'gray-bg',
	components: {
    	ActionButton
  	},
	data() {
		return {
			address: [],
			defaultAddress: '',
			defalultIcon: '',
		};
	},
	computed: {		
		hasList() {
			return this.address.length === 0 ? false : true
		}
	},
	methods: {
		loadAddressList() {
			api.order.getJingdongAddressList((res) => {
				
				this.address = [];
				//排序地址，将最后创建的地址排在前面
				var addressList = res.addresses.sort((a, b) => {
					return b.id - a.id;
				});
				addressList.forEach((a) => {
					this.address.push(a);
				});
				this.address.forEach(e => {
					e.default ? (e.defaultAddress = "true" , e.defalultIcon = true) : (e.defaultAddress = "" , e.defalultIcon = false);
				});
				
				// var defaultSelectedAddress = this.address.length > 0 ? this.address[0] : null;
				// if (defaultSelectedAddress == null) {
				// 	this.$alertDialog('请先添加地址');
				// }
				// this.$refs.address.setCurrAddress(defaultSelectedAddress);
				this.loadOrderInfo();
			});
		},
		select(address) {
			this.$emit('onAddressChange', address);
		},
		setDefault(address) {
			api.order.setDefault(address.id,(res) => {
				this.loadAddressList()
			})
		},
		deleteAddress(address) {
			this.$confirmDialog('确认删除？', (btn) => {
				if (btn == '确定') {
					api.order.deleteAddress(
						address.id,
						(res) => {
							this.$toast('删除成功');
							this.loadAddressList();
						},
						(r) => {
							this.$alertDialog(r.msg);
						}
					);
				}
			});
		},
		goTo(url) {
			this.$router.push(url);
		}
	},
	mounted() {
		this.loadAddressList();
	},
};
</script>

<style scoped lang="less">
.wrap.actions {
	background: #f2f2f2;
}
.address-list {
	padding-bottom: 17vw;
}
.address {
	padding: 3.87vw 4.13vw;
	background: #fff;
	border-top: 1px solid #f5f5f5;
	
	.detail {
		font-size: 3.47vw;
		color: #999;
		margin: 3.6vw auto;
	}
}
.recieve-wrap {
	font-size: 4vw;
	color: #404040;
	display: flex;
	justify-content: space-between;
}
.flex-wrap {
	display: flex;
}
.action-wrap{
	display: flex;
	justify-content: space-between;
		.icon {
			width: 3.47vw;
			height: 3.47vw;
			margin-right: 2vw;
		}
}
.default-address ,.write-btn,.delete-btn {
	align-items: center;
	font-size: 3.47vw;
	color: #333;
}
.write-btn {
	margin-right: 6.53vw;
}
.default-address {
	color: #999;
}
.default-address.true {
	color: #FF3333;
}
.empty-list {
	text-align: center;
	p{
		font-size: 4vw;
		color: #999;
	}
	.empty-img {
		width: 40vw;
		height: 28vw;
		margin-top: 26.67vw;
		border: 1px dashed #999;
	}
}


</style>



// WEBPACK FOOTER //
// src/pages/setting/AddressList.vue